import React from 'react'
import { ListNav } from './index'
import { FloatingFilter } from '../../../components'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'
import PaginatedList from './paginated-list'

const MainContentMobile = ({organizations}) => {
  const location = useLocation()
  const query = qs.parse(location.search)

  return <>
    <ListNav />
    <section className="container mx-auto">
      <div className="flex flex-wrap -mx-4 pb-5">
        <main className="w-full px-4">
          <PaginatedList
            query={query}
            defaultData={organizations}
          />
        </main>
      </div>
    </section>
    <FloatingFilter isOrganization/>
  </>
}

export { MainContentMobile }
